/* ECLIPSE STUDIOS* — Session 26 / FIX-PROMPT E
   E1: Das Aufblaettern haengt wieder am gepinnten ScrollTrigger aus hero-split.js.
       Der Vorgaenger dieser Datei (book-swipe.js) hat gsap.timeline abgefangen, die
       Timeline pausiert zurueckgegeben und die Seiten selbst per horizontalem Wisch
       gefuehrt. Das ist ersatzlos entfallen. Ohne den Haken baut hero-split.js seine
       Timeline wieder ganz normal mit ScrollTrigger, und Scrollen von oben nach unten
       blaettert das Buch auf. Es gibt hier bewusst keinen Ersatz-Mechanismus.
   E2: Geblieben ist der Tap auf das Buch (B2, fuehrt zur Produktseite). Der Link steht
       als <a> im Markup und bringt Tap, Klick, Enter, Fokusring, Mittelklick und
       Kontextmenue nativ mit. Nur eines kann CSS nicht: eine Trefferflaeche, die der
       wechselnden Buchgroesse folgt. Genau das und nichts anderes macht diese Datei.

   Warum .bk-persp vermessen wird und nicht #bkScene: die Szene steht auf inset:0 und
   fuellt damit die ganze Buehne. Eine Trefferflaeche in dieser Groesse waere ein
   bildschirmfuellender Link, der jeden Klick auf der Sektion schluckt. .bk-persp ist der
   Perspektiv-Container direkt um das Buch: er traegt die Buchgroesse, nimmt die mobile
   Verkleinerung der Szene mit und wird selbst nicht animiert. Die Timeline dreht und
   verschiebt erst seine Kinder (.bk-rig, .bk-shift), und Transforms von Kindern aendern
   die Layout-Box des Elternteils nicht. Das Rechteck steht also still. */
(function () {
  'use strict';

  var stage = document.getElementById('fbStage');
  var tap = document.getElementById('bkTap');
  var scene = stage && (stage.querySelector('.bk-persp') || document.getElementById('bkBook'));
  if (!stage || !scene || !tap) return;

  /* Grosszuegig genug fuer einen Daumen, ohne in die Nachbarelemente zu greifen. */
  var PAD = 16;

  /* Erst setzen, wenn wirklich alles gefunden wurde. Faellt dieses Skript aus, greift
     keine einzige .es2-booktap-Regel und die Seite bleibt exakt wie ohne JS. */
  document.documentElement.classList.add('es2-booktap');

  var raf = 0;

  /* Beide Rechtecke stammen aus demselben Frame. Die Szene ist ein Nachfahre der Buehne,
     ihre Differenz ist also auch dann stabil, wenn ScrollTrigger die Buehne gepinnt hat
     und per transform verschiebt. */
  function place() {
    raf = 0;
    var r = scene.getBoundingClientRect();
    var s = stage.getBoundingClientRect();
    if (!r.width || !r.height) return;
    tap.style.left = (r.left - s.left - PAD) + 'px';
    tap.style.top = (r.top - s.top - PAD) + 'px';
    tap.style.width = (r.width + PAD * 2) + 'px';
    tap.style.height = (r.height + PAD * 2) + 'px';
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(place);
  }

  schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', function () { setTimeout(schedule, 240); });
  /* hero-split.js misst das Buch bei jedem ScrollTrigger-Refresh neu (sizeBook). */
  if (window.ScrollTrigger) ScrollTrigger.addEventListener('refresh', schedule);
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(scene);
})();
